var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEconomicDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.45 49.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6a2663;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.72,0A24.73,24.73,0,1,1,0,24.72,24.73,24.73,0,0,1,24.72,0Zm0,4.22a20.5,20.5,0,1,0,20.5,20.5A20.5,20.5,0,0,0,24.72,4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.24,17.63H25.16V15.68h4.08Zm-13.3,9.06h-3v-2h3Zm4,0H17v-2h3Zm3.95,0h-3v-2h3Zm-8,4h-3V28.78h3Zm4,0H17V28.78h3Zm3.95,0h-3V28.78h3Zm-8,4h-3v-2h3Zm4,0H17v-2h3Zm3.95,0h-3v-2h3ZM34.38,17.63H30.29V15.68h4.09Zm-5.14,4H25.16v-2h4.08Zm5.14,0H30.29v-2h4.09Zm-5.14,4H25.16v-2h4.08Zm5.14,0H30.29v-2h4.09Zm-5.14,4H25.16v-2h4.08Zm5.14,0H30.29v-2h4.09ZM29.68,9.51l-8.29,3.36v.72h1.72V20.1l-4.67-1.88-8.29,3.36v.73h1V37.66h16V32.57h5.13v5.09h3.91V13.59h1.81v-.72Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomicDevelopment);
export default __webpack_public_path__ + "static/media/economic-development.fc33645e8f1433fd3c6bf002d813aab2.svg";
export { ForwardRef as ReactComponent };